import React, {Fragment} from 'react';
import WorksSection from "./WorksSection";
import portfolio from "../../../consumers/portfolio";
import PageTitle from '../../components/PageTitle';

class WorksPage extends WorksSection {

    componentDidMount() {
        const reference = this.props.reference;
        if (reference) {
            reference.once('value').then(this.postsHandler);
        }
    }

    render() {
        return (
            <Fragment>
                <PageTitle title={"Portfolio"}/>
                {super.render()}
            </Fragment>
        );
    }

}

export default portfolio(WorksPage);


// WEBPACK FOOTER //
// ./src/visitors/subscribers/works/WorksPage.js